import type { Job } from '../api';
import { formatDateTime } from '../format';
import { StatusBadge } from './StatusBadge';

export const JOB_TYPE_LABELS: Record<Job['type'], string> = {
  provision: 'Création',
  'update-channel': 'Changement de canal',
  remove: 'Retrait',
};

export function JobDetail({ job }: { job: Job }) {
  return (
    <div className="job-detail">
      <p>
        <strong>{JOB_TYPE_LABELS[job.type]}</strong> · {job.username} <StatusBadge status={job.status} />
        {job.dryRun && <span className="badge badge-gray"> Simulation</span>}
      </p>
      <p className="muted">
        Créée le {formatDateTime(job.createdAt)} · Terminée le {formatDateTime(job.finishedAt)}
      </p>
      {job.error && (
        <div className="alert alert-error" role="alert">
          {job.error}
        </div>
      )}
      {job.steps.length === 0 ? (
        <p className="muted">Aucune étape enregistrée.</p>
      ) : (
        <ol className="steps">
          {job.steps.map((s, i) => (
            <li key={`${s.name}-${i}`} className={`step step-${s.status}`}>
              <span className="step-name">{s.name}</span>
              <StatusBadge status={s.status} />
              {s.at && <span className="muted step-at">{formatDateTime(s.at)}</span>}
              {s.detail && <span className="step-detail">{s.detail}</span>}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
